import { Suspense, lazy } from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import NotFoundError from "../ErrorScreens/NotFoundError";
import { ScreenLoader } from "../LoadingSpinner";
import ProtectedRouteElement from "../ProtectedRouteElement";

// Lazy load all page components
const BRFSelectPage = lazy(() => import("../../pages/BRFSelectPage"));
const BookingInfoPage = lazy(() => import("../../pages/BookingInfoPage"));
const BookingSelectPage = lazy(() => import("../../pages/BookingSelectPage"));
const DashboardPage = lazy(() => import("../../pages/DashboardPage"));
const LoginPage = lazy(() => import("../../pages/LoginPage"));
const OverviewPage = lazy(() => import("../../pages/OverviewPage"));
const QNAPage = lazy(() => import("../../pages/QNAPage"));
const QuestionairePage = lazy(() => import("../../pages/QuestionairePage"));
const FastighetPage = lazy(() => import("../../pages/SettingsPage"));
const SubscriptionPage = lazy(() => import("../../pages/SubscriptionPage"));
const UserInfoPage = lazy(() => import("../../pages/UserInfoPage"));
const AddBuildingPage = lazy(() => import("../../pages/AddBuldingPage"));
const AddNodePage = lazy(() => import("../../pages/AddNodePage"));
const AddSequencePage = lazy(() => import("../../pages/AddSequencePage"));
const EditBasicInformationPage = lazy(() => import("../../pages/EditBasicInformationPage"));
const EditNodePage = lazy(() => import("../../pages/EditNodePage/EditNodePage"));
const LoggedOutAboutPage = lazy(() => import("../../pages/LoggedOutAboutPage"));
const NodeDetailsPage = lazy(() => import("../../pages/NodeDetailsPage"));
const SequenceDetailsPage = lazy(() => import("../../pages/SequenceDetailsPage"));
const CategoryPage = lazy(() => import("../../pages/SettingsPage/subpages").then(module => ({ default: module.CategoryPage })));

const ProtectedLayout = () => {
  return (
    <ProtectedRouteElement>
      <Outlet />
    </ProtectedRouteElement>
  );
};

const AppRouter = () => {
  return (
    <Suspense fallback={<ScreenLoader />}>
      <Routes>
        {/* Protected Routes - all wrapped in a single ProtectedRouteElement instance */}
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/booking" element={<BookingSelectPage />} />
          <Route path="/booking/form" element={<BookingInfoPage />} />
          <Route path="/user/information" element={<UserInfoPage />} />
          <Route path="/maintenanceplan" element={<DashboardPage />} />
          <Route path="/maintenanceplan/sequence/:sequenceId" element={<SequenceDetailsPage />} />
          <Route path="/maintenanceplan/add/:parentid" element={<AddSequencePage />} />
          <Route path="/property" element={<FastighetPage />} />
          <Route path="/property/edit" element={<EditBasicInformationPage />} />
          <Route path="/property/add/building/:parentid" element={<AddBuildingPage />} />
          <Route path="/property/add/node/:parentid" element={<AddNodePage />} />
          <Route path="/property/:category" element={<CategoryPage />} />
          <Route path="/property/:parentid/:type/:nodeid" element={<NodeDetailsPage />} />
          <Route path="/property/:parentid/:type/:nodeid/edit" element={<EditNodePage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/support" element={<QNAPage />} />
          <Route path="/onboarding" element={<QuestionairePage />} />
          <Route path="/association/select" element={<BRFSelectPage />} />
        </Route>

        {/* Public routes - no protection */}
        <Route path="/authentication/login" element={<LoginPage />} />
        <Route path="/authentication/about" element={<LoggedOutAboutPage />} />
        
        {/* This route still needs individual protection */}
        <Route
          path="/authentication/select"
          element={
            <ProtectedRouteElement>
              <BRFSelectPage />
            </ProtectedRouteElement>
          }
        />
        
        {/* 404 route */}
        <Route path="*" element={<NotFoundError />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;